export default __webpack_public_path__ + "static/media/Freebooter's Jerkin of the Elder Bond.dac56136.jpg";